import React from 'react';
import {
  Checkbox as CheckboxChakra,
  FormControl,
  FormErrorMessage,
} from '@chakra-ui/react';
import {
  Controller,
  Control,
  FieldValues,
  RegisterOptions,
} from 'react-hook-form';

interface CheckboxProps {
  name: string;
  control: Control<FieldValues>;
  label: string;
  rules?: RegisterOptions;
  error?: any;
}

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  control,
  label,
  rules,
  error,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={false}
      render={({ onChange, value }) => (
        <FormControl mt="35px" mb="20px" isInvalid={error}>
          <CheckboxChakra
            iconColor="#0092B0"
            size="lg"
            color="#888888"
            isChecked={value}
            onChange={e => onChange(e.target.checked)}
          >
            {label}
          </CheckboxChakra>
          <FormErrorMessage>{error?.message}</FormErrorMessage>
        </FormControl>
      )}
    />
  );
};

export default Checkbox;
